//
// 定数
//
import CartypeAllImg from '@/assets/cartypes/all.jpg'
import CartypeOpenImg from '@/assets/cartypes/open.jpg'
import CartypeSuvImg from '@/assets/cartypes/suv.jpg'
import CartypeGrImg from '@/assets/cartypes/gr.jpg'

//
// 標準オプションID
//
export const PET_ID = -1
export const CHILDSEAT_ID = -2
export const STUDLESS_ID = -3

//
// オプションの料金計算種別
//
export const PRICETYPE_DAY = 0
export const PRICETYPE_TIME = 1

//
// 送迎・配車サービスのメソッド
//
export const WAY_NONE = 0
export const WAY_START = 1
export const WAY_RETURN = 2
export const WAY_ROUND = 3

//
// 車両種別
//
export const cartypes = [{
  code: 'all',
  name: 'すべて',
  image: CartypeAllImg
},
{
  code: 'gr',
  name: 'GR/GR SPORT',
  image: CartypeGrImg
},
{
  code: 'open',
  name: 'オープン',
  image: CartypeOpenImg
},
{
  code: 'suv',
  name: 'SUV',
  image: CartypeSuvImg
}]

export const cartypeNames = {
  suv: 'SUV',
  gr: 'GR/GR SPORT',
  open: 'オープン'
}

//
// 乗車定員
//
export const seats = [{
  code: 'all',
  name: '指定なし',
  first: 0,
  last: 999
},
{
  code: 's02',
  name: '1〜2名',
  first: 1,
  last: 2
},
{
  code: 's04',
  name: '3〜4名',
  first: 3,
  last: 4
},
{
  code: 's05',
  name: '5名以上',
  first: 5,
  last: 999
}]

//
// 空き状況の表示期間
//
export const TIMELINE_DAYS = 2 * 7 // 2 weeks
